var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};

// libs/ui-components/src/lib/modules/card/card.element.ts
import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

// libs/ui-components/src/lib/modules/card/card.style.ts
import { css } from "lit";
var cardStyle = css`
    
    :host {
        background-color: var(--color-background-bg-primary);
        border-radius: 24px;
        width: fit-content;
        height: fit-content;
        display: block;
    }

    :host(.shadow) {
        box-shadow: 0 -3px 4px 0 var(--primary-12), 0 6px 12px 0 var(--primary-12);
    }

    :host(.mobile) {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        width: 100vw;
        height: fit-content;
        box-shadow: none;
    }
    
    .card-content {
        padding: 8px;
        display: flex;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        flex-direction: column;
        gap: 8px;
    }

`;

// libs/ui-components/src/lib/modules/card/card.element.ts
var CardElement = class extends LitElement {
  constructor() {
    super(...arguments);
    this.forMobileView = false;
    this.showShadow = false;
  }
  render() {
    return html`
      <slot name="header"></slot>
      <div class="card-content">
        <slot></slot>
      </div>
    `;
  }
  firstUpdated() {
    if (this.forMobileView && !this.classList.contains("mobile")) {
      this.classList.add("mobile");
    }
    if (this.showShadow && !this.classList.contains("shadow")) {
      this.classList.add("shadow");
    }
  }
};
CardElement.tagName = "inch-card";
CardElement.styles = cardStyle;
__decorateClass([
  property({ type: Boolean })
], CardElement.prototype, "forMobileView", 2);
__decorateClass([
  property({ type: Boolean })
], CardElement.prototype, "showShadow", 2);
CardElement = __decorateClass([
  customElement(CardElement.tagName)
], CardElement);

// libs/ui-components/src/lib/modules/card/card-header.element.ts
import { html as html2, LitElement as LitElement2 } from "lit";
import { customElement as customElement2, property as property2 } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

// libs/ui-components/src/lib/modules/card/card-header.style.ts
import { css as css2 } from "lit";
import { mobileMediaCSS } from "@one-inch-community/core/lit";
var cardHeaderStyle = css2`

    :host {
        display: flex;
        height: 60px;
        width: 100%;
        padding: 16px 16px 0;
        box-sizing: border-box;
        border-top-left-radius: 32px;
        border-top-right-radius: 32px;
    }
    
    :host(.not-native-mode) {
        height: 44px;
        padding: 0;
    }

    .card-header-container {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        width: 100%;
        height: 100%;
    }

    .position-container {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        color: var(--color-content-content-primary);
        gap: 8px;
        word-wrap: break-word;
        white-space: nowrap;
    }

    .center-container {
        justify-content: center;
    }

    .left-container {
        justify-content: flex-start;
    }

    .right-container {
        justify-content: flex-end;
    }

    .card-header-title {
        font-size: 20px;
        font-weight: 600;
        line-height: 28px;
        letter-spacing: 0;
        text-align: center;
    }
    
    .card-header-title__left:not(.card-header-title__and-back) {
        margin-left: 8px;
    }

    .card-header-title__left:not(.card-header-title__and-back):dir(rtl) {
        margin-right: 8px;
    }

    ${mobileMediaCSS(css2`
        .card-header-title {
            font-size: 16px;
        }
        :host {
            padding: 8px 8px 0;
        }
    `)}

`;

// libs/ui-components/src/lib/modules/card/card-header.element.ts
import "@one-inch-community/ui-components/icon";
import "@one-inch-community/ui-components/button";
import { dispatchEvent } from "@one-inch-community/core/lit";
var CardHeaderElement = class extends LitElement2 {
  constructor() {
    super();
    this.headerTextPosition = "center";
    this.backButton = false;
    this.closeButton = false;
    this.slotDirty = {};
    this.slot = "header";
  }
  render() {
    return html2`
      <div class="card-header-container">
        <div class="position-container left-container">
          <slot @slotchange="${() => this.onSlotChange("left")}" name="left-container"></slot>
          ${this.getBackButton("left")}
          ${this.getHeader("left")}
        </div>
        <div class="position-container center-container">
          <slot @slotchange="${() => this.onSlotChange("center")}" name="center-container"></slot>
          ${this.getHeader("center")}
        </div>
        <div class="position-container right-container">
          <slot @slotchange="${() => this.onSlotChange("right")}" name="right-container"></slot>
          ${this.getCloseButton("right")}
        </div>
      </div>
    `;
  }
  firstUpdated() {
    if (this.parentElement?.localName !== "inch-card") {
      this.classList.add("not-native-mode");
    }
  }
  getHeader(containerName) {
    const isSlotDirty = this.slotDirty[containerName] ?? false;
    const classes = {
      "card-header-title": true,
      [`card-header-title__${containerName}`]: true,
      "card-header-title__and-back": this.backButton
    };
    return this.headerTextPosition === containerName && !isSlotDirty ? html2`
      <span class="${classMap(classes)}">${this.headerText}</span>
    ` : "";
  }
  getBackButton(containerName) {
    const isSlotDirty = this.slotDirty[containerName] ?? false;
    return this.backButton && !isSlotDirty ? html2`
      <inch-button @click="${(event) => dispatchEvent(this, "backCard", null, event)}" size="l" type="tertiary-gray">
        <inch-icon icon="arrowLeft24"></inch-icon>
      </inch-button>
    ` : "";
  }
  getCloseButton(containerName) {
    const isSlotDirty = this.slotDirty[containerName] ?? false;
    return this.closeButton && !isSlotDirty ? html2`
      <inch-button @click="${(event) => dispatchEvent(this, "closeCard", null, event)}" size="l" type="tertiary-gray">
        <inch-icon icon="cross24"></inch-icon>
      </inch-button>
    ` : "";
  }
  onSlotChange(slotName) {
    this.slotDirty = { ...this.slotDirty, [slotName]: true };
    this.requestUpdate();
  }
};
CardHeaderElement.tahName = "inch-card-header";
CardHeaderElement.styles = cardHeaderStyle;
__decorateClass([
  property2({ type: String, attribute: true })
], CardHeaderElement.prototype, "headerText", 2);
__decorateClass([
  property2({ type: String, attribute: true })
], CardHeaderElement.prototype, "headerTextPosition", 2);
__decorateClass([
  property2({ type: Boolean, attribute: true })
], CardHeaderElement.prototype, "backButton", 2);
__decorateClass([
  property2({ type: Boolean, attribute: true })
], CardHeaderElement.prototype, "closeButton", 2);
CardHeaderElement = __decorateClass([
  customElement2(CardHeaderElement.tahName)
], CardHeaderElement);
export {
  CardElement,
  CardHeaderElement
};
//# sourceMappingURL=index.esm.js.map
